import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const destinations = {
  parent: "/dashboard/settings",
  coach: "/coach/settings",
  staff: "/staff/settings",
  admin: "/admin/settings",
  superadmin: "/admin/settings",
};

export function SettingsRoute() {
  const auth = useAuth();
  const location = useLocation();
  if (!auth.ready) return <main className="route-loading" aria-live="polite">Loading account settings…</main>;
  if (!auth.isAuthenticated) return <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}${location.hash}` }} />;
  return <Navigate to={destinations[auth.user?.role] || "/"} replace />;
}
